import React from 'react';

const Banner = () => {
  return (
    <section className="w-full">
      <img
        src="/assets/banner.jpg"
        alt="REALATION Banner"
        className="w-full 
                   h-[30vh] 
                   sm:h-[40vh] 
                   md:h-[60vh] 
                   lg:h-[80vh] 
                   xl:h-[700px] 
                   object-cover"
      />
    </section>
  );
};

export default Banner;
